import { boxStyle } from 'lib/styles/index';
import palette from 'lib/styles/palette';
import { changeProp } from 'modules/serviceSlice';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

const StoreSearchBoxRow = ({ store, setFocused }) => {
  const dispatch = useDispatch();

  return (
    <div
      onClick={() => {
        dispatch(changeProp({ key: 'storeSearchWord', value: store.store }));
        dispatch(changeProp({ key: 'storeId', value: store.storeId }));
        setFocused(false);
      }}
    >
      {store.store}
    </div>
  );
};

const StoreSearchBox = ({ storeList, setFocused }) => {
  return (
    <StoreSearchBoxBlock>
      {storeList.length === 0 ? (
        <div>검색 결과가 없습니다</div>
      ) : (
        storeList?.map(store => (
          <StoreSearchBoxRow
            key={store.storeId}
            store={store}
            setFocused={setFocused}
          />
        ))
      )}
    </StoreSearchBoxBlock>
  );
};

export default StoreSearchBox;

const StoreSearchBoxBlock = styled.div`
  ${boxStyle}
  width: 350px;
  max-height: 300px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  top: 40px;
  right: 0px;

  div {
    cursor: pointer;
    &:hover {
      color: ${palette.theme[3]};
    }
  }

  div + div {
    margin-top: 10px;
  }
`;
